import { render, staticRenderFns } from "./mags_types.vue?vue&type=template&id=82c49bae&"
import script from "./mags_types.vue?vue&type=script&lang=js&"
export * from "./mags_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports